import { BaseEntity } from '../core/entities/base.entity';
import { MetadataFieldDataType } from '../core/types';

export class GlobalMetaDataEntity extends BaseEntity {
  name!: string;
  description?: string;
  changedBy?: string;
  updated?: Date;
  fieldConfig?: MetadataField[];
  isConsumerField?: boolean;
}

export interface MetadataField {
  name: string
  label?: string
  secondaryLabel?: string
  mandatory?: boolean
  datatype: MetadataFieldDataType
  detail?: MetadataFieldDetail
  subFieldConf?: MetadataField[]
}

export interface MetadataFieldDetail {
  apiGetURL?: string
  label?: string
  subLabel?: string
  key?: string
  redaLabel?: string
  headers?: MetadataFieldHeader[]
}

export interface MetadataFieldHeader {
  name: string
  values: string[]
}
